import { nodeEnv } from '@/environment';
import { logger } from '@/services/logger';

function getEmbedScriptUrl({ nodeEnv, isV2 }: { nodeEnv: string; isV2: boolean }) {
    const cacheBuster = Date.now();
    return `https://${nodeEnv === 'prod' ? 'agent' : nodeEnv === 'staging' ? 'agent-staging' : 'agent-dev'}.d-id.com/${isV2 ? 'v2' : 'v1'}/index.js?v=${cacheBuster}`;
}

export async function loadAgentsClientScript({ isV2 }: { isV2: boolean }) {
    try {
        delete (window as any)['DID_AGENT_INIT'];
        delete (window as any)['DID_AGENT_API'];
    } catch (e) {
        logger.error('Error deleting DID_AGENT_INIT and DID_AGENT_API', e);
    }

    const url = getEmbedScriptUrl({ nodeEnv, isV2 });

    // dynamic import
    const mod = await import(/* @vite-ignore */ url);

    // its possible because agents-ui exports init and getAuth functions
    if (mod && typeof mod.init === 'function') {
        return {
            init: (props: any) =>
                mod.init({
                    ...props,
                    auth: mod.getAuth({
                        token: props.token,
                        username: props.username,
                        password: props.password,
                        clientKey: props.clientKey,
                    }),
                }),
        };
    }

    // fallback
    if ((window as any)['DID_AGENT_INIT']) {
        return { init: (window as any)['DID_AGENT_INIT'] };
    }

    throw new Error('init() not found in loaded module');
}
